<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Drukarki M3250, MS622">
     Drukarki M3250, MS622
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_pl" title="Informacje dotyczące bezpieczeństwa">
     Informacje dotyczące bezpieczeństwa
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Definicje pojęć">
      Definicje pojęć
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="Informacje dotyczące produktu">
      Informacje dotyczące produktu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_pl" title="Informacje na temat drukarki">
     Informacje na temat drukarki
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_pl" title="Znajdowanie informacji na temat drukarki">
      Znajdowanie informacji na temat drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_pl" title="Wyb&oacute;r miejsca na drukarkę">
      Wyb&oacute;r miejsca na drukarkę
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_pl" title="Wyposażenie drukarki">
      Wyposażenie drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_pl" title="Podłączanie kabli">
      Podłączanie kabli
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_pl" title="Korzystanie z&nbsp;panelu sterowania">
      Korzystanie z&nbsp;panelu sterowania
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_pl" title="Odczytywanie wskazań przycisku zasilania i kontrolki">
      Odczytywanie wskazań przycisku zasilania i kontrolki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-network-setup-page-topic.html#printing-network-setup-page_pl" title="Drukowanie strony z konfiguracją sieci">
      Drukowanie strony z konfiguracją sieci
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_pl" title="Konfigurowanie i używanie aplikacji na ekranie gł&oacute;wnym">
     Konfigurowanie i używanie aplikacji na ekranie gł&oacute;wnym
    </a>
   </p>
   <div id="divd0e748">
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_pl" title="Korzystanie z ekranu gł&oacute;wnego">
      Korzystanie z ekranu gł&oacute;wnego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_pl" title="Dostosowywanie ekranu gł&oacute;wnego">
      Dostosowywanie ekranu gł&oacute;wnego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-display-customization-topic.html#using-display-customization_pl" title="Korzystanie z funkcji Dostosowywanie wyświetlacza">
      Korzystanie z funkcji Dostosowywanie wyświetlacza
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-eco-settings-topic.html#configuring-eco-settings_pl" title="Konfigurowanie ustawień oszczędnych">
      Konfigurowanie ustawień oszczędnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-customer-support-topic.html#using-customer-support_pl" title="Korzystanie z aplikacji Wsparcie klienta">
      Korzystanie z aplikacji Wsparcie klienta
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-qr-code-generator-topic.html#using-qr-code-generator_pl" title="Korzystanie z aplikacji Generator kod&oacute;w QR">
      Korzystanie z aplikacji Generator kod&oacute;w QR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-device-quotas-topic.html#setting-up-device-quotas_pl" title="Konfigurowanie aplikacji Limity urządzenia">
      Konfigurowanie aplikacji Limity urządzenia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#creating-cloud-connector-profile_pl" title="Tworzenie profilu Cloud Connector">
      Tworzenie profilu Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-bookmarks-topic.html#d0e1094" title="Zarządzanie zakładkami">
      Zarządzanie zakładkami
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adding-contacts-topic.html#d0e1171" title="Zarządzanie kontaktami">
      Zarządzanie kontaktami
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-accessibility-features-chapter.html#setting-up-using-accessibility-features-chapter_pl" title="Konfiguracja i używanie funkcji dostępności">
     Konfiguracja i używanie funkcji dostępności
    </a>
   </p>
   <div id="divd0e1290">
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#activating-voice-guidance_pl" title="Aktywowanie prowadzenia głosowego">
      Aktywowanie prowadzenia głosowego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="navigating-screen-using-gestures-topic.html#navigating-screen-using-gestures_pl" title="Obsługa ekranu za pomocą gest&oacute;w">
      Obsługa ekranu za pomocą gest&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-magnification-mode-topic.html#enabling-magnification-mode_pl" title="Włączanie trybu powiększania">
      Włączanie trybu powiększania
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-voice-guidance-speech-rate-topic.html#adjusting-voice-guidance-speech-rate_pl" title="Dostosowywanie tempa mowy w prowadzeniu głosowym">
      Dostosowywanie tempa mowy w prowadzeniu głosowym
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-keyboard-on-display-topic.html#using-keyboard-on-display_pl" title="Używanie klawiatury ekranowej">
      Używanie klawiatury ekranowej
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-spoken-passwords-or-personal-identifcation-numbers-topic.html#enabling-spoken-passwords-or-personal-identifcation-numbers_pl" title="Włączanie funkcji wypowiadania haseł lub osobistych numer&oacute;w identyfikacyjnych">
      Włączanie funkcji wypowiadania haseł lub osobistych numer&oacute;w identyfikacyjnych
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_pl" title="Ładowanie papieru i nośnik&oacute;w specjalnych">
     Ładowanie papieru i nośnik&oacute;w specjalnych
    </a>
   </p>
   <div id="divd0e1495">
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#setting-paper-size-and-type_pl" title="Ustawianie rozmiaru i typu papieru">
      Ustawianie rozmiaru i typu papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-m-topic.html#configuring-universal-paper-settings-m_pl" title="Konfigurowanie ustawień uniwersalnego rozmiaru papieru">
      Konfigurowanie ustawień uniwersalnego rozmiaru papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_pl" title="Ładowanie zasobnik&oacute;w">
      Ładowanie zasobnik&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_pl" title="Ładowanie nośnik&oacute;w do podajnika uniwersalnego">
      Ładowanie nośnik&oacute;w do podajnika uniwersalnego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_pl" title="Łączenie zasobnik&oacute;w">
      Łączenie zasobnik&oacute;w
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_pl" title="Podp&oacute;rka papieru">
     Podp&oacute;rka papieru
    </a>
   </p>
   <div id="divd0e1662">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-goldfinger-topic.html#supported-paper-sizes-goldfinger_pl" title="Obsługiwane rozmiary papieru">
      Obsługiwane rozmiary papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-goldfinger-topic.html#supported-paper-types-goldfinger_pl" title="Obsługiwane typy papieru">
      Obsługiwane typy papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-goldfinger-topic.html#supported-paper-weights-goldfinger_pl" title="Obsługiwane gramatury papieru">
      Obsługiwane gramatury papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_pl" title="Niedozwolone rodzaje papieru">
      Niedozwolone rodzaje papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_pl" title="Używanie papieru pochodzącego z recyklingu">
      Używanie papieru pochodzącego z recyklingu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_pl" title="Drukowanie">
     Drukowanie
    </a>
   </p>
   <div id="divd0e2521">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_pl" title="Drukowanie z komputera">
      Drukowanie z komputera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e2547" title="Drukowanie z urządzenia przenośnego">
      Drukowanie z urządzenia przenośnego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_pl" title="Drukowanie z napędu flash">
      Drukowanie z napędu flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_pl" title="Obsługiwane napędy flash i typy plik&oacute;w">
      Obsługiwane napędy flash i typy plik&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_pl" title="Konfiguracja poufnych zadań">
      Konfiguracja poufnych zadań
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_pl" title="Drukowanie zadań poufnych i innych zadań wstrzymanych">
      Drukowanie zadań poufnych i innych zadań wstrzymanych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_pl" title="Drukowanie za pomocą profilu Cloud Connector">
      Drukowanie za pomocą profilu Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_pl" title="Drukowanie listy wzorc&oacute;w czcionek">
      Drukowanie listy wzorc&oacute;w czcionek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_pl" title="Drukowanie listy katalog&oacute;w">
      Drukowanie listy katalog&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_pl" title="Anulowanie zadania drukowania">
      Anulowanie zadania drukowania
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_pl" title="Opis menu drukarki">
     Opis menu drukarki
    </a>
   </p>
   <div id="divd0e3057">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_pl" title="Mapa menu">
      Mapa menu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e3376" title="Urządzenie">
      Urządzenie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e5222" title="Drukuj">
      Drukuj
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e6480" title="Papier">
      Papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e6742" title="Napęd USB">
      Napęd USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e6963" title="Sieć/porty">
      Sieć/porty
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e8753" title="Bezpieczeństwo">
      Bezpieczeństwo
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e9888" title="Raporty">
      Raporty
     </a>
    </p>
    <p class="toc-2-style">
     <a href="help-topic.html#help_pl" title="Pomoc">
      Pomoc
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#d0e10136" title="Rozwiązywanie problem&oacute;w">
      Rozwiązywanie problem&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_pl" title="Drukowanie strony ustawień menu">
      Drukowanie strony ustawień menu
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_pl" title="Zabezpieczanie drukarki">
     Zabezpieczanie drukarki
    </a>
   </p>
   <div id="divd0e10188">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_pl" title="Lokalizowanie gniazda zabezpieczeń">
      Lokalizowanie gniazda zabezpieczeń
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_pl" title="Czyszczenie pamięci drukarki">
      Czyszczenie pamięci drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-hard-disk-memory-topic.html#erasing-printer-hard-disk-memory_pl" title="Wymazywanie dysku twardego drukarki">
      Wymazywanie dysku twardego drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="encrypting-printer-hard-disk-topic.html#encrypting-printer-hard-disk_pl" title="Szyfrowanie dysku twardego drukarki">
      Szyfrowanie dysku twardego drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_pl" title="Przywracanie ustawień fabrycznych">
      Przywracanie ustawień fabrycznych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_pl" title="Informacje o ulotności pamięci">
      Informacje o ulotności pamięci
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_pl" title="Przegląd drukarki">
     Przegląd drukarki
    </a>
   </p>
   <div id="divd0e10402">
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_pl" title="Konfigurowanie alarm&oacute;w e-mail">
      Konfigurowanie alarm&oacute;w e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-default-headphone-volume-topic.html#adjusting-default-headphone-volume_pl" title="Dostosowywanie domyślnej głośności słuchawek">
      Dostosowywanie domyślnej głośności słuchawek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e10464" title="Sieć">
      Sieć
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-serial-printing-topic.html#setting-up-serial-printing_pl" title="Konfigurowanie drukowania przy użyciu portu szeregowego (tylko system Windows)">
      Konfigurowanie drukowania przy użyciu portu szeregowego (tylko system Windows)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_pl" title="Czyszczenie drukarki">
      Czyszczenie drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_pl" title="Zamawianie części i materiał&oacute;w eksploatacyjnych">
      Zamawianie części i materiał&oacute;w eksploatacyjnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e11200" title="Wymiana części i materiał&oacute;w eksploatacyjnych">
      Wymiana części i materiał&oacute;w eksploatacyjnych
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer-group.html#d0e11344" title="Przenoszenie drukarki">
      Przenoszenie drukarki
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-energy-paper.html#d0e11400" title="Oszczędzanie energii i papieru">
      Oszczędzanie energii i papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling.html#d0e11504" title="Recykling">
      Recykling
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_pl" title="Usuwanie zacięć">
     Usuwanie zacięć
    </a>
   </p>
   <div id="divd0e11537">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_pl" title="Zapobieganie zacięciom">
      Zapobieganie zacięciom
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_pl" title="Ustalanie miejsca wystąpienia zacięcia">
      Ustalanie miejsca wystąpienia zacięcia
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_pl" title="Zacięcie papieru w drzwiczkach A">
      Zacięcie papieru w drzwiczkach A
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_pl" title="Zacięcie papieru w obszarze tylnych drzwiczek">
      Zacięcie papieru w obszarze tylnych drzwiczek
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_pl" title="Zacięcie papieru w pojemniku standardowym">
      Zacięcie papieru w pojemniku standardowym
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_pl" title="Zacięcie papieru w module drukowania dwustronnego">
      Zacięcie papieru w module drukowania dwustronnego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_pl" title="Zacięcie papieru w zasobnikach">
      Zacięcie papieru w zasobnikach
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_pl" title="Zacięcie papieru w&nbsp;podajniku uniwersalnym">
      Zacięcie papieru w&nbsp;podajniku uniwersalnym
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_pl" title="Rozwiązywanie problem&oacute;w">
     Rozwiązywanie problem&oacute;w
    </a>
   </p>
   <div id="divd0e11813">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e11816" title="Problemy z połączeniem sieciowym">
      Problemy z połączeniem sieciowym
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e12130" title="Problem z&nbsp;opcjami sprzętowymi">
      Problem z&nbsp;opcjami sprzętowymi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e12404" title="Problemy z materiałami eksploatacyjnymi">
      Problemy z materiałami eksploatacyjnymi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printer-problems.html#solving-printer-problems_pl" title="Problemy z podawaniem papieru">
      Problemy z podawaniem papieru
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_pl" title="Problemy z drukowaniem">
      Problemy z drukowaniem
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_pl" title="Kontakt z obsługą klienta">
      Kontakt z obsługą klienta
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-migrating-chapter.html#upgrading-migrating-chapter_pl" title="Usprawnienia i przenoszenie">
     Usprawnienia i przenoszenie
    </a>
   </p>
   <div id="divd0e15393">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e15396" title="Sprzęt">
      Sprzęt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e15706" title="Oprogramowanie">
      Oprogramowanie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e15789" title="Oprogramowanie sprzętowe">
      Oprogramowanie sprzętowe
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_pl" title="Informacje">
     Informacje
    </a>
   </p>
   <div id="divd0e15876">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15879" title="Informacje o produkcie">
      Informacje o produkcie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e15896" title="Informacje o wydaniu">
      Informacje o wydaniu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_pl" title="Znaki towarowe">
      Znaki towarowe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_pl" title="Oświadczenia dotyczące licencji">
      Oświadczenia dotyczące licencji
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_pl" title="Poziomy emisji hałasu">
      Poziomy emisji hałasu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_pl" title="Dyrektywa WEEE dotycząca zużytego sprzętu elektrycznego i elektronicznego">
      Dyrektywa WEEE dotycząca zużytego sprzętu elektrycznego i elektronicznego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16000" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_pl" title="Wyrzucanie produkt&oacute;w">
      Wyrzucanie produkt&oacute;w
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16034" title="Akumulator litowo-jonowy">
      Akumulator litowo-jonowy
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_pl" title="Rozporządzenie (UE) 2023/1542">
      Rozporządzenie (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_pl" title="Zwrot kaset firmy Lexmark w celu ponownego użycia lub recyklingu">
      Zwrot kaset firmy Lexmark w celu ponownego użycia lub recyklingu
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_pl" title="Ostrzeżenie o podatności na ładunki elektrostatyczne">
      Ostrzeżenie o podatności na ładunki elektrostatyczne
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_pl" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_pl" title="Informacje o temperaturze">
      Informacje o temperaturze
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_pl" title="Oświadczenie dotyczące lasera">
      Oświadczenie dotyczące lasera
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_pl" title="Zużycie energii">
      Zużycie energii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16274" title="Uwagi dotyczące przepis&oacute;w związanych z produktami bezprzewodowymi">
      Uwagi dotyczące przepis&oacute;w związanych z produktami bezprzewodowymi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_pl" title="Uwagi dotyczące składnika modułowego">
      Uwagi dotyczące składnika modułowego
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_pl" title="Zagrożenie promieniowaniem o częstotliwości radiowej">
      Zagrożenie promieniowaniem o częstotliwości radiowej
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e16300" title="Zgodność z dyrektywami Wsp&oacute;lnoty Europejskiej">
      Zgodność z dyrektywami Wsp&oacute;lnoty Europejskiej
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_pl" title="Zgodność z dyrektywami Wsp&oacute;lnoty Europejskiej">
      Zgodność z dyrektywami Wsp&oacute;lnoty Europejskiej
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_pl" title="Oświadczenie dotyczące zakł&oacute;ceń radiowych">
      Oświadczenie dotyczące zakł&oacute;ceń radiowych
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue